export default __webpack_public_path__ + "images/GI.00f9820.png";